import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e0872734"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "trip-header" }
const _hoisted_2 = { class: "back-button" }
const _hoisted_3 = {
  key: 0,
  class: "calendar-cards"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "grid" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["src"]
const _hoisted_8 = { key: 2 }
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  class: "image-gallery"
}
const _hoisted_11 = { class: "gallery-header" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "gallery-title" }, "Billedgalleri", -1))
const _hoisted_13 = { class: "gallery-actions" }
const _hoisted_14 = { class: "gallery-toggle" }
const _hoisted_15 = { class: "gallery-grid" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeroSection = _resolveComponent("HeroSection")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_CalendarCard = _resolveComponent("CalendarCard")!
  const _component_ContentCard = _resolveComponent("ContentCard")!
  const _component_GoogleMap = _resolveComponent("GoogleMap")!
  const _component_SliderToggle = _resolveComponent("SliderToggle")!
  const _component_ImageUploadForm = _resolveComponent("ImageUploadForm")!
  const _component_ImageCarousel = _resolveComponent("ImageCarousel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.trip)
      ? (_openBlock(), _createBlock(_component_HeroSection, {
          key: 0,
          images: _ctx.heroImages,
          title: _ctx.trip.location,
          dates: _ctx.formatDateRange(_ctx.trip.startDate, _ctx.trip.endDate)
        }, null, 8, ["images", "title", "dates"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_b_button, {
          style: {"height":"65px"},
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Tilbage ")
          ]),
          _: 1
        })
      ]),
      (_ctx.trip)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (!_ctx.$store.getters.windowWidthLessThan600px)
              ? (_openBlock(), _createElementBlock("h2", _hoisted_4, _toDisplayString(_ctx.trip.year), 1))
              : _createCommentVNode("", true),
            _createVNode(_component_CalendarCard, {
              "start-date": _ctx.trip?.startDate,
              "end-date": _ctx.trip?.endDate
            }, null, 8, ["start-date", "end-date"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_ContentCard, { class: "description" }, {
        default: _withCtx(() => [
          (_ctx.trip)
            ? (_openBlock(), _createElementBlock("h1", _hoisted_6, _toDisplayString(_ctx.trip?.location + (_ctx.$store.getters.windowWidthLessThan600px ? ` (${_ctx.trip?.year})` : "")), 1))
            : _createCommentVNode("", true),
          _createElementVNode("p", null, _toDisplayString(_ctx.trip?.address), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.trip?.description), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_ContentCard, { class: "map" }, {
        default: _withCtx(() => [
          (_ctx.trip?.address)
            ? (_openBlock(), _createBlock(_component_GoogleMap, {
                key: 0,
                address: _ctx.trip?.address
              }, null, 8, ["address"]))
            : (_ctx.loading)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: require('@/assets/Loading_icon.gif')
                }, null, 8, _hoisted_7))
              : (_openBlock(), _createElementBlock("p", _hoisted_8, "Addresse mangler"))
        ]),
        _: 1
      }),
      (_ctx.locationImageUri)
        ? (_openBlock(), _createBlock(_component_ContentCard, {
            key: 0,
            class: "location-image"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", { src: _ctx.locationImageUri }, null, 8, _hoisted_9)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    (_ctx.gallery)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createTextVNode(" Mine billeder "),
                _createVNode(_component_SliderToggle, {
                  toggle: _ctx.galleryFilterMyImages,
                  "onUpdate:toggle": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.galleryFilterMyImages) = $event))
                }, null, 8, ["toggle"])
              ]),
              _createElementVNode("button", {
                class: "upload-button",
                onClick: _cache[2] || (_cache[2] = () => _ctx.showUploadImage = true)
              }, " Upload ")
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gallery, (image, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: image.id,
                class: "gallery-item",
                onClick: ($event: any) => (_ctx.showGalleryCarousel(index))
              }, [
                _createElementVNode("img", {
                  src: (image.thumbUri ?? image.uri) + '?' + _ctx.token
                }, null, 8, _hoisted_17)
              ], 8, _hoisted_16))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.trip)
      ? (_openBlock(), _createBlock(_component_ImageUploadForm, {
          key: 2,
          showForm: _ctx.showUploadImage,
          "onUpdate:showForm": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showUploadImage) = $event)),
          year: _ctx.trip.year,
          onSubmitted: _ctx.fetchGallery
        }, null, 8, ["showForm", "year", "onSubmitted"]))
      : _createCommentVNode("", true),
    (_ctx.gallery)
      ? (_openBlock(), _createBlock(_component_ImageCarousel, {
          key: 3,
          show: _ctx.showImageCarousel,
          "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showImageCarousel) = $event)),
          selectedIndex: _ctx.selectedImage,
          "onUpdate:selectedIndex": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedImage) = $event)),
          images: _ctx.gallery
        }, null, 8, ["show", "selectedIndex", "images"]))
      : _createCommentVNode("", true)
  ], 64))
}